import angular from 'angular';
import pageBack from './page-back';

let directiveModule = angular.module('app.directives', [])

.directive('pageBack', pageBack)

.name;

export default directiveModule;



// WEBPACK FOOTER //
// ./client/app/common/directives/directives.js